import { createReduxAsyncThunk } from 'shared/utils';

import { stationsAPI } from 'entities/stations';

import { STATIONS_STATE } from '../../constants';

export const deleteStationsPriceReportSettings = createReduxAsyncThunk<{}>(
  `${STATIONS_STATE}/deleteStationsPriceReportSettings`,
  async () => {
    const { data } = await stationsAPI.deleteStationsPriceReportSettings();
    return data;
  }
);
